module.exports = __webpack_public_path__ + "static/media/Bre Arder.015a001a.jpg";